import { __ } from '@wordpress/i18n';
import { useEffect } from '@wordpress/element';

import "./popup.scss";

const Popup = ({
	children,
	headerTitle,
	headerImage,
	onClose,
	escClose = true,
	closeButton = true,
	clickOutsideClose = true,
	className = ''
}) => {
	
	useEffect(() => {
		const handleClickOutside = (e) => {
			if (clickOutsideClose && e.target === document.querySelector('.wds-popup')) {
				onClose();
			}
		};

		const handleEscClick = (e) => {
			if (escClose && e.key === 'Escape') {
				onClose();
			}
		};

		if (escClose) {
			window.addEventListener('keydown', handleEscClick);
		}

		if (clickOutsideClose) {
			window.addEventListener('click', handleClickOutside);
		}

		return () => {
			window.removeEventListener('keydown', handleEscClick);
			window.removeEventListener('click', handleClickOutside);
		};
	}, [escClose, clickOutsideClose, onClose]);

	return (
		<div className={`wds-popup ${className}`}>
			<div className="wds-popup__inner">
				<div className="wds-popup__header">
					<div className="wds-popup__header-icon">
						{headerImage}
					</div>
					<h3 className="wds-popup__title">{headerTitle}</h3>
				</div>
				<div className="wds-popup__content">
					{children}

					<div className="wds-popup__footer">
						{closeButton && (
							<a
								className="wds-popup__button--close"
								href="#"
								onClick={(e) => {
									e.preventDefault();
									onClose();
								}}
							>
								{__('Cancel', 'jckwds')}
							</a>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Popup;